var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.source === 'font-awesome')?_c('FontAwesomeIcon',_vm._g(_vm._b({attrs:{"icon":[_vm.prefix, _vm.name]}},'FontAwesomeIcon',_vm.$attrs,false),_vm.$listeners)):(_vm.source === 'custom')?_c('span',_vm._g(_vm._b({class:_vm.customIconClass},'span',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }